import { DefaultClient } from 'rest-resource/dist/client'

// Injected at build time by vue.config.js - same name and local default as
// nudgey-api's POLYSIGMA_API_URL.
export const API_BASE_URL = process.env.POLYSIGMA_API_URL

// Per the standards, API interfaces go through `rest-resource`. The
// marketing site only ever makes anonymous calls (the beta form), so there's
// no auth header to inject.
export class ApiClient extends DefaultClient {}

export const apiClient = new ApiClient(API_BASE_URL)

// DRF error bodies are {detail: '...'} or {field: ['...']} - flatten either
// into one sentence the form can show as-is.
export function describeApiError(error) {
    const response = error && error.response
    if (!response) return 'We couldn’t send your request. Check your connection and try again.'

    const data = response.data || {}
    if (typeof data.detail === 'string') return data.detail
    const firstField = Object.keys(data)[0]
    if (firstField) {
        const value = data[firstField]
        return Array.isArray(value) ? value[0] : String(value)
    }
    return 'We couldn’t send your request. Try again in a moment.'
}
